(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var productInfo = document.querySelector('product-info');
    if (!productInfo) return;

    var PRODUCT_ID = (productInfo.getAttribute('data-product-id') || '').trim();
    var AUCTION_ID = '';
    var CUSTOMER_ID = window.staCurrentCustomerId ? window.staCurrentCustomerId() : '';

    var API_BASE = (window.staAuctionsBase ? window.staAuctionsBase() : localStorage.getItem('sterlings_base_url') || '').replace(/\/+$/, '');
    if (!API_BASE) {
      console.warn('[auction] API base missing');
      paintStoreFallback();
      return;
    }

    var auctionHeaders = window.staAuctionHeaders ? window.staAuctionHeaders() : { Accept: 'application/json' };

    function storeDollars() {
      return window.staStorePriceDollars
        ? window.staStorePriceDollars(productInfo)
        : null;
    }

    function auctionShowUrl(auctionId) {
      if (window.staAuctionShowPath) {
        return API_BASE + window.staAuctionShowPath(auctionId, CUSTOMER_ID);
      }
      var path = '/api/auctions/' + encodeURIComponent(auctionId);
      if (CUSTOMER_ID) path += '?platform_customer_id=' + encodeURIComponent(CUSTOMER_ID);
      return API_BASE + path;
    }

    function auctionBidHistoryUrl(auctionId) {
      return API_BASE + '/api/auctions/' + encodeURIComponent(auctionId) + '/bid_history';
    }

    function setMoneyPrice(el, dollars) {
      if (!el) return;
      if (window.staSetMoneyEl) window.staSetMoneyEl(el, dollars);
      else if (window.staFormatMoney) el.innerHTML = window.staFormatMoney(dollars);
    }

    function moneyPlain(dollars) {
      return window.staFormatMoneyPlain ? window.staFormatMoneyPlain(dollars) : '$' + dollars + ' CAD';
    }

    // Date + exact time, e.g. "September 02, 2026 at 1:00 A.M EDT" (visitor
    // locale/timezone, timezone label from sta-time.js).
    function fmtDate(iso) {
      try {
        var d = new Date(iso);
        if (window.staFormatDateTime) return window.staFormatDateTime(d, 'long');
        return d.toLocaleString();
      } catch (e) {
        return '';
      }
    }

    // Bid timestamps in the history modal, e.g. "9/2/2026, 1:00:12 AM EDT".
    function stampOf(iso) {
      try {
        var d = new Date(iso);
        if (window.staFormatStamp) return window.staFormatStamp(d);
        return d.toLocaleString();
      } catch (e) {
        return '—';
      }
    }

    function secsParts(ms) {
      var s = Math.max(0, Math.floor(ms / 1000));
      var d = Math.floor(s / 86400);
      s -= d * 86400;
      var h = Math.floor(s / 3600);
      s -= h * 3600;
      var m = Math.floor(s / 60);
      var sec = s % 60;
      return { d: d, h: h, m: m, s: sec };
    }

    function setText(el, txt) {
      if (el) el.textContent = txt;
    }

    function pdpPriceDebug(source, detail) {
      if (!window.STA_AUCTION_DEBUG && localStorage.getItem('sta_auction_debug') !== '1') return;
      console.log('[sta-pdp-price]', source, detail);
    }

    var priceWrap = document.querySelector('.product-price__body .product-price__container');
    var priceTitleEl = document.querySelector('[data-sta-auction-price-label]');
    var priceEl = document.querySelector('[data-sta-auction-live-price]');
    var maxBidEl = document.querySelector('[data-sta-auction-max-bid]');
    var maxBidValueEl = document.querySelector('[data-sta-auction-max-bid-value]');
    var bidsCountEl = document.querySelector('.product-price__bids-count');
    var bidsRowEl = document.querySelector('[data-sta-bids-row]');
    var historyLink = document.querySelector('.product-price__bids-body a');
    var endSpecBody = document.querySelector('.product-price__date .sta-product-spec .sta-product-spec__body');
    var endTitleEl = endSpecBody ? endSpecBody.querySelector('.sta-product-spec__title') : null;
    var endCountdown = endSpecBody ? endSpecBody.querySelector('p') : null;
    if (endSpecBody && !endCountdown) {
      endCountdown = document.createElement('p');
      endSpecBody.appendChild(endCountdown);
    }

    var modal = document.getElementById('auction-bids-modal');
    var tbody = document.getElementById('auction-bids-tbody');

    /**
     * Repaints the price from the store's own value when the auction API is
     * unreachable or the lot has no auction at all.
     *
     * The label is left alone unless a caller passes one: Liquid has already
     * rendered the right label for this lot's state, and a lot with no auction
     * (an archived Buy Now lot) must never be relabelled "Starting bid:" when it
     * never took a bid.
     */
    function paintStoreFallback(label) {
      var dollars = storeDollars();
      if (dollars == null) return;
      if (priceTitleEl && label) priceTitleEl.textContent = label;
      if (priceEl) setMoneyPrice(priceEl, dollars);
    }

    /**
     * Hands this lot's win/outbid state to the shared badge module, which owns
     * the markup and keeps the PDP, the cards, and the account page in step.
     */
    function paintBidStatus(attrs, auctionId) {
      if (!window.staBidStatus) return;

      var id = String(auctionId || '').trim();
      if (!id) return;

      var slot = document.querySelector('.product-price__bid-status');
      if (slot) slot.setAttribute('data-sta-bid-status-for', id);

      window.staBidStatus.set(id, window.staBidStatus.stateFromAuctionAttrs(attrs));
    }

    function syncAuctionIdInUrl(auctionId) {
      try {
        var pageUrl = new URL(location.href);
        if (!pageUrl.searchParams.get('auction_id')) {
          pageUrl.searchParams.set('auction_id', auctionId);
          history.replaceState({}, '', pageUrl.toString());
        }
      } catch (e) {}
    }

    function paintFromAttrs(attrs, meta) {
      meta = meta || {};
      var storeFallback = storeDollars();
      var bids = attrs.bids_count != null ? attrs.bids_count : attrs.bid_count;
      var bidNum = parseInt(bids, 10) || 0;
      var current = null;

      if (bidNum > 0 && attrs.current_price != null && attrs.current_price !== '') {
        current = Number(attrs.current_price);
      } else if (window.staAuctionDisplayPrice) {
        current = window.staAuctionDisplayPrice(attrs, storeFallback);
      } else if (attrs.current_price != null) {
        current = attrs.current_price;
      } else if (storeFallback != null) {
        current = storeFallback;
      } else {
        current = 0;
      }

      pdpPriceDebug(meta.source || 'paintFromAttrs', {
        auctionId: meta.auctionId || AUCTION_ID,
        query: meta.query || '',
        bids_count: bids,
        current_price: attrs.current_price,
        starting_price: attrs.starting_price,
        initial_price: attrs.initial_price,
        storeFallback: storeFallback,
        resolvedLivePrice: current,
        priceEstimateFromShopify:
          window.staGetPriceEstimateForProductId && PRODUCT_ID
            ? window.staGetPriceEstimateForProductId(PRODUCT_ID)
            : '',
        priceEl: priceEl ? '[data-sta-auction-live-price]' : null,
      });
      var endIso = attrs.end_date || attrs.end_at;
      var st = String(attrs.status || '').toLowerCase();
      var statusEnded = /disabled|ended|archive|complete|cancel/.test(st);
      var endMs = endIso ? Date.parse(endIso) : NaN;
      var timeEnded = !isNaN(endMs) && endMs <= Date.now();
      var isEnded = statusEnded || timeEnded;
      var winnerRaw = attrs.winner_id != null ? attrs.winner_id : attrs.winner_customer_id;
      var hasWinner =
        winnerRaw != null &&
        String(winnerRaw).trim() !== '' &&
        String(winnerRaw).toLowerCase() !== 'null';

      if (isEnded && !hasWinner && storeFallback != null) {
        current = storeFallback;
      }

      var startIso = attrs.start_date || attrs.start_at;
      var startMs = startIso ? Date.parse(startIso) : NaN;
      var notYetOpen = !isNaN(startMs) && startMs > Date.now();

      if (priceTitleEl) {
        if (isEnded && hasWinner) priceTitleEl.textContent = 'Hammer Price:';
        else if (isEnded) priceTitleEl.textContent = 'Buy now price:';
        else if (notYetOpen) priceTitleEl.textContent = 'Starting bid:';
        else if (bidNum > 0) priceTitleEl.textContent = 'Last bid price:';
        else priceTitleEl.textContent = 'Starting bid:';
      }

      if (priceWrap) {
        priceWrap.classList.toggle('product-price__container--hammer', isEnded && hasWinner);
        priceWrap.classList.remove('product-price__container--past');
      }
      if (priceEl) {
        priceEl.classList.toggle('product-price__price--hammer', isEnded && hasWinner);
        if (current != null && isFinite(Number(current))) setMoneyPrice(priceEl, current);
      }

      // The bidder's own max, beside the current bid.
      //
      // `current_user_bid` is returned only for the platform_customer_id this
      // request carried, and is absent entirely when that customer has no max on
      // the lot — so this element can never show anyone else's maximum, and a
      // logged-out visitor gets nothing. Hidden once the auction ends: the number
      // is a bidding aid, and sitting next to a hammer price it would only muddle
      // what the lot actually sold for.
      if (maxBidEl) {
        var myMaxRaw = attrs.current_user_bid ? attrs.current_user_bid.amount : null;
        var myMax = myMaxRaw == null || myMaxRaw === '' ? NaN : Number(myMaxRaw);
        if (!isEnded && isFinite(myMax) && myMax > 0) {
          if (maxBidValueEl) setText(maxBidValueEl, moneyPlain(myMax));
          maxBidEl.hidden = false;
        } else {
          maxBidEl.hidden = true;
        }
      }

      // "Winning" / "Outbid" beside the price. The show response already carries
      // this customer's `current_user_bid`, so the badge costs no extra request
      // — and, like the max bid above, it can only ever describe the requester.
      paintBidStatus(attrs, meta.auctionId || AUCTION_ID);

      if (bidsCountEl) {
        setText(bidsCountEl, bidNum + ' ' + (bidNum === 1 ? 'Bid' : 'Bids'));
      }

      // Sold lots earn the bids row back only when there is a real history behind
      // it. Marked in Liquid rather than decided here, so a lot still on sale keeps
      // showing "0 Bids" while it waits for its first one. A sold lot whose auction
      // never resolves never reaches this line, and stays hidden — which is the
      // wanted outcome for an archived Buy Now lot.
      if (bidsRowEl && bidsRowEl.hasAttribute('data-sta-bids-row-needs-bids')) {
        bidsRowEl.hidden = bidNum < 1;
      }

      // Upcoming lots (not yet open) count down to the START; live/ended lots
      // count down to the END. Only upcoming changes; everything else is unchanged.
      if (notYetOpen && startIso) {
        if (endTitleEl) endTitleEl.textContent = 'Bidding Starts: ' + fmtDate(startIso);
        if (endSpecBody) {
          endSpecBody.setAttribute('data-end-iso', startIso);
          endSpecBody.setAttribute('data-countdown-kind', 'start');
        }
      } else {
        if (endTitleEl && endIso) endTitleEl.textContent = 'Bidding Ends: ' + fmtDate(endIso);
        if (endSpecBody) {
          endSpecBody.setAttribute('data-end-iso', endIso || '');
          endSpecBody.setAttribute('data-countdown-kind', 'end');
        }
      }

      return { endIso: endIso };
    }

    function loadShow(auctionId) {
      var showQuery = auctionShowUrl(auctionId);
      pdpPriceDebug('request', { auctionId: auctionId, url: showQuery });
      return fetch(showQuery, {
        headers: auctionHeaders,
        mode: 'cors',
      })
        .then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.json();
        })
        .then(function (a) {
          var data = a && a.data && !Array.isArray(a.data) ? a.data : a;
          var attrs = data && data.attributes ? data.attributes : data;
          return paintFromAttrs(attrs || {}, {
            source: 'GET /api/auctions/:id',
            auctionId: auctionId,
            query: showQuery,
          });
        })
        .catch(function (e) {
          console.warn('[auction] show failed', e);
          paintStoreFallback();
        });
    }

    /**
     * One refetch for a burst of callers. A single bid raises a bid update, an
     * outbid notice and often an extension within the same second, and each
     * asks for a repaint.
     */
    var repaintTimer = null;
    var repaintWaiters = [];

    function scheduleRepaint() {
      return new Promise(function (resolve) {
        repaintWaiters.push(resolve);
        if (repaintTimer) return;
        repaintTimer = setTimeout(function () {
          repaintTimer = null;
          var waiters = repaintWaiters;
          repaintWaiters = [];
          var done = function () {
            tickCountdown();
            waiters.forEach(function (w) { w(); });
          };
          if (AUCTION_ID) loadShow(AUCTION_ID).then(done);
          else done();
        }, 250);
      });
    }

    // In the closing minutes the page also asks the server itself, so a missed
    // bid or extension corrects itself within one interval even with no socket.
    var FINAL_MINUTES_MS = 5 * 60 * 1000;
    var FINAL_POLL_MS = 15 * 1000;
    var lastFinalPollAt = 0;

    // A countdown reaching zero is only a guess: a bid in the last seconds may
    // have extended the lot, and the extension event may never have arrived.
    // The page shows "Closing…" and asks the server before it says "Ended".
    var END_CHECK_TRIES = 3;
    var END_CHECK_RETRY_MS = 5 * 1000;
    var endCheck = { iso: '', tries: 0, inFlight: false, nextAt: 0, done: false };
    // Only a countdown seen running gets checked; a lot that had already ended
    // when the page loaded was painted from the server and reads "Ended" at once.
    var sawEndCountdownRunning = false;

    /** True while the end time is still being confirmed with the server. */
    function confirmingEnd(iso) {
      if (!sawEndCountdownRunning || !AUCTION_ID) return false;
      if (endCheck.iso !== iso) {
        endCheck = { iso: iso, tries: 0, inFlight: false, nextAt: 0, done: false };
      }
      if (endCheck.done) return false;
      if (endCheck.inFlight || Date.now() < endCheck.nextAt) return true;

      endCheck.inFlight = true;
      endCheck.tries += 1;
      var check = endCheck;
      scheduleRepaint().then(function () {
        check.inFlight = false;
        // A moved end date starts a fresh countdown; nothing more to confirm here.
        if (check.tries >= END_CHECK_TRIES) check.done = true;
        else check.nextAt = Date.now() + END_CHECK_RETRY_MS;
        tickCountdown();
      });
      return true;
    }

    function tickCountdown() {
      if (!endSpecBody) return;
      var iso = endSpecBody.getAttribute('data-end-iso');
      if (!iso) {
        if (endCountdown) endCountdown.textContent = '';
        return;
      }
      var kind = endSpecBody.getAttribute('data-countdown-kind') || 'end';
      var ms = Date.parse(iso) - Date.now();
      var p = secsParts(ms);

      if (kind === 'end' && ms > 0) {
        sawEndCountdownRunning = true;
        if (AUCTION_ID && ms <= FINAL_MINUTES_MS && Date.now() - lastFinalPollAt >= FINAL_POLL_MS) {
          lastFinalPollAt = Date.now();
          scheduleRepaint();
        }
      }

      if (p.d + p.h + p.m + p.s <= 0) {
        if (kind === 'start') setText(endCountdown, 'Bidding is open');
        else setText(endCountdown, confirmingEnd(iso) ? 'Closing…' : 'Ended');
      } else {
        setText(
          endCountdown,
          p.d + ' days ' + p.h + ' hours ' + p.m + ' mins ' + String(p.s).padStart(2, '0') + 's ' +
            (kind === 'start' ? 'until start' : 'left')
        );
      }
    }

    function loadBids(auctionId) {
      if (!tbody) return;
      tbody.innerHTML = '<tr><td colspan="3" style="text-align:center;opacity:.7">Loading…</td></tr>';

      fetch(auctionBidHistoryUrl(auctionId), {
        headers: auctionHeaders,
        mode: 'cors',
      })
        .then(function (r) {
          if (r.ok) return r.json();
          return fetch(API_BASE + '/api/auctions/' + encodeURIComponent(auctionId) + '/bids', {
            headers: auctionHeaders,
            mode: 'cors',
          }).then(function (fallback) {
            if (!fallback.ok) throw new Error('HTTP ' + fallback.status);
            return fallback.json();
          });
        })
        .then(function (payload) {
          var rows = Array.isArray(payload?.data) ? payload.data : Array.isArray(payload) ? payload : [];
          if (!rows.length) {
            tbody.innerHTML = '<tr><td colspan="3" style="text-align:center;opacity:.7">No bids yet</td></tr>';
            return;
          }
          var html = rows
            .map(function (row) {
              var b = row.attributes || row;
              var who = b.platform_customer_name || 'Bidder #' + (b.platform_customer_id || '—');
              var text = who.trim();
              var maskedFirst, maskedLast;
              if (text && !text.includes('*')) {
                var parts = text.split(' ');
                var firstName = parts[0] || '';
                var lastName = parts[1] || '';
                maskedFirst = firstName.charAt(0) + '****';
                maskedLast = lastName ? '' + lastName.charAt(0) : '';
              }
              var amt = moneyPlain(b.amount);
              var when = b.placed_at ? stampOf(b.placed_at) : '—';
              return (
                '<tr><td>' +
                escapeHtml(maskedFirst) +
                escapeHtml(maskedLast) +
                '</td><td>' +
                amt +
                '</td><td>' +
                escapeHtml(when) +
                '</td></tr>'
              );
            })
            .join('');
          tbody.innerHTML = html;
        })
        .catch(function (e) {
          tbody.innerHTML =
            '<tr><td colspan="3" style="text-align:center;color:#b91c1c">Failed to load bids</td></tr>';
          console.warn('[auction] bids failed', e);
        });
    }

    function escapeHtml(s) {
      return String(s || '').replace(/[&<>"]/g, function (m) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[m];
      });
    }

    function openModal() {
      if (!modal || !AUCTION_ID) return;
      modal.hidden = false;
      loadBids(AUCTION_ID);
    }

    function closeModal(e) {
      if (!modal) return;
      if (!e || e.target.hasAttribute('data-close')) modal.hidden = true;
    }

    if (modal) {
      modal.addEventListener('click', closeModal);
      document.addEventListener('keydown', function (ev) {
        if (ev.key === 'Escape') modal.hidden = true;
      });
    }

    if (historyLink) {
      historyLink.addEventListener('click', function (ev) {
        ev.preventDefault();
        openModal();
      });
    }

    var resolvePromise = window.staResolveAuctionIdAsync
      ? window.staResolveAuctionIdAsync(PRODUCT_ID)
      : Promise.resolve(window.staResolveAuctionId ? window.staResolveAuctionId() : '');

    resolvePromise.then(function (auctionId) {
      AUCTION_ID = String(auctionId || '').trim();
      if (AUCTION_ID) {
        syncAuctionIdInUrl(AUCTION_ID);
        // Subscribing in theme.liquid only covers an id known at page load or a
        // lot in the first page of /api/auctions; this covers every lot page.
        if (window.staWatchAuction) window.staWatchAuction(AUCTION_ID);
      } else {
        paintStoreFallback();
      }

      return AUCTION_ID ? loadShow(AUCTION_ID) : Promise.resolve();
    }).then(function () {
      tickCountdown();
    });

    // Authoritative repaint of the PDP price block (label, value, bid count,
    // countdown) from GET /api/auctions/:id. Exposed so the bid-placement and
    // real-time (Pusher) paths can reconcile the display without a page reload.
    window.staRepaintAuctionPdp = function () {
      return scheduleRepaint();
    };

    // The socket came back or the tab came into view: events may have been missed.
    document.addEventListener('sta:live-resync', function () {
      if (AUCTION_ID) scheduleRepaint();
    });

    setInterval(tickCountdown, 1000);
  });
})();
